import { makeStyles } from '@material-ui/core/styles';

const AVATAR_CONTAINER_HEIGHT = 40;

// Copied from InventoryProfileLayout/styles.js (accountableBar, divider): V1 is not imported.
// Internal: only ProfileAccountableBar uses them, so the barrel does not export them.
export const useStyles = makeStyles(theme => ({
  barContainer: {
    padding: theme.spacing(0.5)
  },
  recruiterDivider: {
    height: AVATAR_CONTAINER_HEIGHT,
    margin: theme.spacing(0, 2)
  }
}));
